import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../contexts/AppContext";
import { LoadingContent } from "../Shared/LoadingContent";
import { API_JobAlerts, API_UpdateJobAlerts, JobAlertInfoModel } from "../../../apis/ApisJobAlerts";
import { ExpanderCard } from "../Shared/ExpanderCard";
import toast from "react-hot-toast";

export function JobAlertsForm() {
    const app = useContext(AppContext);

    const [data, setDetails] = useState<JobAlertInfoModel>(null);
    const [saving, setSaving] = useState<boolean>(false);
    const [consent, setConsent] = useState<boolean>(false);

    useEffect(() => {
        async function asyncCall() {
            var res = await API_JobAlerts();
            setDetails(res);
        }

        if (!app.loading && data == null) {
            asyncCall();
        }
    }, [app.loading]);

    const saveDetails = async () => {
        setSaving(true);
        await API_UpdateJobAlerts({ Departments: data.Departments, Categories: data.Categories, Functions: data.Functions, Titles: data.Titles, Cities: data.Cities });
        toast.success("Saved");
        setSaving(false);
    }

    let dateString = new Date(data?.ExplicitConsentExpiration).toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });

    return (
        <LoadingContent loading={data == null} classes={""}>
            {!data?.CanView && <div className="alert alert-info">Please submit an application to setup alerts</div>}

            {data?.Feature_EmailVerification && !data?.EmailVerified && <div className="alert alert-warning">You have not verified your email yet.<br />To use the job alert facility, please verify your email address or go to the Home page to request a new verification email.</div>}

            {data != null && data.CanView && (!data.Feature_EmailVerification || data.EmailVerified) && <>
                {data.DepartmentsRowVisible && data.Departments != null && data.Departments.length > 0 &&
                    <ExpanderCard title={app.positions.Features.DisplayText_Department} icon="fa-solid fa-building-columns" defaultOpenState={true} buttonkey={"Departments"} key={"Departments"} >
                        <div className="card-body">
                            <div className="d-flex flex-wrap">
                                {data.Departments.map(x => {
                                    return <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={`DEP_${x.DepartmentRef}`}>
                                        <input id={`checkbox_DEP_${x.DepartmentRef}`} type="checkbox" className="form-check-input me-2" disabled={saving} checked={x.Selected} onChange={e => {
                                            let list = data.Departments.slice();
                                            let match = data.Departments.findIndex(fi => fi.DepartmentRef == x.DepartmentRef);
                                            list[match].Selected = e.currentTarget.checked;
                                            setDetails({ ...data, Departments: list });
                                        }} />
                                        <label className="form-check-label no-highlight-clicker me-1" htmlFor={`checkbox_DEP_${x.DepartmentRef}`}>
                                            {x.Department}
                                        </label>
                                    </div>
                                })}
                            </div>
                        </div>
                    </ExpanderCard>}

                {data.LocationsRowVisible && data.Cities != null && data.Cities.length > 0 &&
                    <ExpanderCard title="Locations" icon="fa-solid fa-location-dot" defaultOpenState={true} buttonkey={"Locations"} key={"Locations"} >
                        <div className="card-body">
                            <div className="d-flex flex-wrap">
                                {data.Cities.map(x => {
                                    return <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={`CITY_${x.City}`}>
                                        <input id={`checkbox_CITY_${x.City}`} type="checkbox" className="form-check-input me-2" disabled={saving} checked={x.Selected} onChange={e => {
                                            let list = data.Cities.slice();
                                            let match = data.Cities.findIndex(fi => fi.City == x.City);
                                            list[match].Selected = e.currentTarget.checked;
                                            setDetails({ ...data, Cities: list });
                                        }} />
                                        <label className="form-check-label no-highlight-clicker me-1" htmlFor={`checkbox_CITY_${x.City}`}>
                                            {x.City}
                                        </label>
                                    </div>
                                })}
                            </div>
                        </div>
                    </ExpanderCard>}

                {data.JobTitlesRowVisible && data.Titles != null && data.Titles.length > 0 &&
                    <ExpanderCard title="Job titles" icon="fa-solid fa-briefcase" defaultOpenState={true} buttonkey={"JobTitles"} key={"JobTitles"} >
                        <div className="card-body">
                            <div className="d-flex flex-wrap">
                                {data.Titles.map(x => {
                                    return <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={`TITLE_${x.JobtitleRef}`}>
                                        <input id={`checkbox_TITLE_${x.JobtitleRef}`} type="checkbox" className="form-check-input me-2" disabled={saving} checked={x.Selected} onChange={e => {
                                            let list = data.Titles.slice();
                                            let match = data.Titles.findIndex(fi => fi.JobtitleRef == x.JobtitleRef);
                                            list[match].Selected = e.currentTarget.checked;
                                            setDetails({ ...data, Titles: list });
                                        }} />
                                        <label className="form-check-label no-highlight-clicker me-1" htmlFor={`checkbox_TITLE_${x.JobtitleRef}`}>
                                            {x.Jobtitle}
                                        </label>
                                    </div>
                                })}
                            </div>
                        </div>
                    </ExpanderCard>}
                {data.JobCategoriesRowVisible && data.Categories != null && data.Categories.length > 0 &&
                    <ExpanderCard title="Job categories" icon="fa-solid fa-layer-group" defaultOpenState={true} buttonkey={"JobCategories"} key={"JobCategories"} >
                        <div className="card-body">
                            <div className="d-flex flex-wrap">
                                {data.Categories.map(x => {
                                    return <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={`CAT_${x.CategoryCode}`}>
                                        <input id={`checkbox_CAT_${x.CategoryCode}`} type="checkbox" className="form-check-input me-2" disabled={saving} checked={x.Selected} onChange={e => {
                                            let list = data.Categories.slice();
                                            let match = data.Categories.findIndex(fi => fi.CategoryCode == x.CategoryCode);
                                            list[match].Selected = e.currentTarget.checked;
                                            setDetails({ ...data, Categories: list });
                                        }} />
                                        <label className="form-check-label no-highlight-clicker me-1" htmlFor={`checkbox_CAT_${x.CategoryCode}`}>
                                            {x.Category}
                                        </label>
                                    </div>
                                })}
                            </div>
                        </div>
                    </ExpanderCard>}

                {data.FunctionsRowVisible && data.Functions != null && data.Functions.length > 0 &&
                    <ExpanderCard title="Functions" icon="fa-solid fa-equals" defaultOpenState={true} buttonkey={"Functions"} key={"Functions"} >
                        <div className="card-body">
                            <div className="d-flex flex-wrap">
                                {data.Functions.map(x => {
                                    return <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={`FUNC_${x.JobFunctionRef}`}>
                                        <input id={`checkbox_FUNC_${x.JobFunctionRef}`} type="checkbox" className="form-check-input me-2" disabled={saving} checked={x.Selected} onChange={e => {
                                            let list = data.Functions.slice();
                                            let match = data.Functions.findIndex(fi => fi.JobFunctionRef == x.JobFunctionRef);
                                            list[match].Selected = e.currentTarget.checked;
                                            setDetails({ ...data, Functions: list });
                                        }} />
                                        <label className="form-check-label no-highlight-clicker me-1" htmlFor={`checkbox_FUNC_${x.JobFunctionRef}`}>
                                            {x.JobFunction}
                                        </label>
                                    </div>
                                })}
                            </div>
                        </div>
                    </ExpanderCard>}

                {data.Feature_DataRetention &&
                    <div className="card card-body mt-3">
                        <p className="">
                            Job alerts are not necessarily relevant indefinitely, we intend to send this job alert until {dateString},
                            we will invite you to renew and extend this period before it expires.
                        </p>
                        <p className="my-2 text-center">
                            <input id={`checkbox_consent`} type="checkbox" className="form-check-input me-2 check-larger check-highlighted" disabled={saving} checked={consent} onChange={e => {
                                setConsent(e.currentTarget.checked)
                            }} />
                            <label className="form-check-label no-highlight-clicker me-1" htmlFor={`checkbox_consent`}>
                                I consent to {app.firmName} holding my data and sending me job alerts until {dateString}.
                            </label>
                        </p>
                        <div className="row">
                            <div className="col-lg-12 text-center">
                                <button className="btn btn-alt mt-4 btn-wider" disabled={data == null || saving || !consent} type="submit" onClick={e => {
                                    e.preventDefault();
                                    saveDetails();
                                }}><i className="fa-solid fa-floppy-disk"></i> Save</button>
                            </div>
                        </div>
                    </div>
                }

                {!data.Feature_DataRetention &&
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <button className="btn btn-alt mt-4 btn-wider" disabled={data == null || saving} type="submit" onClick={e => {
                                e.preventDefault();
                                saveDetails();
                            }}><i className="fa-solid fa-floppy-disk"></i> Save</button>
                        </div>
                    </div>
                }
            </>}
        </LoadingContent>
    );
}